export default __webpack_public_path__ + "static/media/m-slide-2.8a88d6bc.png";